document.addEventListener("DOMContentLoaded", () => {
  const expandLink = document.getElementById("expand-link");

  if (!expandLink) return;

  const targetSelector = expandLink.getAttribute("href");
  const fullDescription = targetSelector
    ? document.querySelector(targetSelector)
    : null;

  if (!fullDescription) return;

  expandLink.addEventListener("click", (event) => {
    event.preventDefault();

    fullDescription.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
});